export const translations = {
  fr: {
  'pricing.header.badge': 'Tarifs',
  'pricing.header.title': 'Choisissez votre plan',
  'pricing.header.subtitle': 'Des tarifs simples et transparents pour tous vos besoins',
  'pricing.toggle.monthly': 'Mensuel',
  'pricing.toggle.yearly': 'Annuel',
  'pricing.yearly.badge': '2 mois offerts',
  'pricing.features.tester.none': 'Testeur : Aucun',
  'pricing.features.performance.none': 'Performance : Aucun',
  'pricing.features.group.none': 'Groupe : Aucun',
  'pricing.card.popular': 'Populaire',
  'pricing.included': 'Inclus par défaut',
  'pricing.subscribe': "S'abonner",
  'pricing.checking': 'Vérification...',
  'pricing.already': 'Déjà abonné',
  'pricing.autorenew': 'Renouvellement automatique',
  'pricing.per.month': 'mois',
  'pricing.per.year': 'an',
    // Navigation
    login: "Connexion",
    signup: "S'inscrire",
    
    // Hero Section
    heroTitle: "30% de performance en plus", 
    heroSubtitle: "Pour tous vos LLM avec une memoire unique",
    heroDescription: "Hiperyon vous permet de switcher de modèle comme de chemise sans avoir à rappeler à l'IA ce que vous voulez.",
    getStarted: "Commencer gratuitement",
    viewPricing: "Voir les tarifs",
    dashboardTitle: "Dashboard Hiperyon",
    
    // Boost Section
    boostTitle: "Obtenez des résultats 30% meilleurs avec Hiperyon",
    boostDescription: "Performances améliorées et rapidité garantie. Votre mémoire contextuelle vous suit dans chaque changement de modèle.",
    
    // Mockup Section
    mockupTitle: "Notre extension \n simple et puissante",
    mockupDescription: "Hiperyon vous permet de gérer vos tokens, de\npersonnaliser vos interactions et de suivre vos\nperformances avec des outils avancés.",
    
    // FAQ
    faqTitle: "Questions Fréquentes",
    faqSubtitle: "Tout ce que vous devez savoir sur Hiperyon",
    faq1Q: "Que fait l'extension Chrome Hiperyon ?",
    faq1A: "Elle ajoute une couche de mémoire aux outils d'IA basés sur navigateur. Elle capture le contexte de vos conversations et le rend disponible sur des outils comme ChatGPT, Claude, Perplexity, etc. Toutes les données personnelles en votre possession sont utilisées pour permettre un fonctionnement optimal, car la mémoire est directement intégrée au LLM que vous utilisez.",
    faq2Q: "L'extension Chrome Hiperyon est-elle gratuite ?",
    faq2A: "Oui, l'extension de base est gratuite. Nous proposons également des plans premium avec des fonctionnalités avancées.",
    faq3Q: "Comment décide-t-elle de ce qu'il faut mémoriser ?",
    faq3A: "Hiperyon utilise des algorithmes d'IA avancés pour identifier et sauvegarder automatiquement les informations les plus pertinentes de vos conversations.",
    faq4Q: "Quels outils d'IA sont pris en charge ?",
    faq4A: "Actuellement, nous prenons en charge ChatGPT, Claude, Perplexity, Gemini et Replit. D'autres intégrations arrivent bientôt !",
    faq5Q: "La mémoire se synchronise-t-elle entre les appareils ?",
    faq5A: "Oui. La mémoire est sauvegardée sur le serveur cloud Hiperyon, donc vos données se synchronisent et fonctionnent sur plusieurs appareils.",
    faq6Q: "Puis-je voir ou modifier ce qui est stocké ?",
    faq6A: "Absolument. Le tableau de bord Hiperyon vous permet de visualiser, rechercher, modifier ou supprimer n'importe quelle mémoire. Vous pouvez également ajouter des mémoires manuellement.",
    faq7Q: "Comment la mémoire est-elle appliquée dans les prompts ?",
    faq7A: "Pour toutes les IA prises en charge, vous pouvez déclencher la mémoire manuellement via un bouton ou un raccourci clavier. Utilisez le raccourci clavier Ctrl+Q pour choisir si l'IA utilise la mémoire ou non. La prise en charge de Perplexity arrive bientôt.",
    faq8Q: "Puis-je désactiver la mémoire pour une session ou un outil spécifique ?",
    faq8A: "Oui. Vous pouvez désactiver la mémoire par outil ou mettre en pause la capture de mémoire entièrement depuis le tableau de bord.",
    faq9Q: "Mes données me appartiennent-elles vraiment ?",
    faq9A: "Oui, 100% de vos données vous appartiennent. Vous avez le contrôle total et pouvez les consulter, les modifier ou les supprimer à tout moment depuis votre tableau de bord.",
    faq10Q: "Vendez-vous mes données à des tiers ?",
    faq10A: "Non, jamais. Nous ne vendons, ne partageons et n'exploitons vos données commercialement. Nous utilisons vos données uniquement pour améliorer votre expérience personnelle.",
    faq11Q: "Comment mes données sont-elles sécurisées ?",
    faq11A: "Vos conversations et mémoires sont chiffrées en transit (SSL/TLS) et au repos. Même nos serveurs ne peuvent pas accéder à vos données sensibles. Nous utilisons les standards de sécurité les plus élevés de l'industrie.",
    faq12Q: "Êtes-vous conforme au RGPD ?",
    faq12A: "Oui, Hiperyon respecte complètement le RGPD et les réglementations de protection des données. Vous avez le droit d'accès, de rectification, d'oubli et de portabilité de vos données.",
    
    // Newsletter
    newsletterTitle: "Tentez de gagner 6 mois gratuits !",
    newsletterDescription: "Inscrivez-vous à notre newsletter et participez au tirage au sort pour remporter 6 mois d'abonnement Hiperyon MAX.",
    newsletterPlaceholder: "Entrez votre adresse email",
    newsletterButton: "Je participe !",
    newsletterDisclaimer: "En vous inscrivant, vous acceptez de recevoir nos actualités et offres exclusives.",
    
    // Loading
    loading: "Chargement...",
    
    // Features Section
    featuresTitle: "Pourquoi Hiperyon ?",
    featuresSubtitle: "Découvrez tout ce qu'Hiperyon peut faire pour vous",
    feature1Title: "Conçu pour la sécurité de vos données",
    feature1Desc: "Hiperyon est conçu pour garantir la confidentialité et la sécurité de vos données personnelles, tout en offrant des performances optimales.",
    feature2Title: "Facilité d'utilisation",
    feature2Desc: "Hiperyon est incroyablement simple à utiliser. Une seule action suffit pour appeler votre mémoire et enrichir vos interactions.",
    feature3Title: "Tarification unique",
    feature3Desc: "Nos prix sont les meilleurs du marché. Profitez d'un plan gratuit pour découvrir notre service sans frais cachés ni carte bancaire requise.",
    feature4Title: "Disponibilité 100%",
    feature4Desc: "Nous essayons de vous garantir un uptime le plus élevé possible, tout le temps, pour que vous puissiez compter sur Hiperyon sans interruption.",
    feature5Title: "Architecture multi-tenant",
    feature5Desc: "Hiperyon vous permet de centraliser vos données d'IA au même endroit, tout en offrant la possibilité de switcher facilement entre différents modèles.",
    feature6Title: "Support client 24/7",
    feature6Desc: "Nous sommes disponibles 100% du temps. Nos agents IA le sont au moins, avec un support dédié pour nos clients premium.",
    feature7Title: "Annulez votre abonnement quand vous voulez",
    feature7Desc: "Si vous n'aimez pas Hiperyon, nous vous convaincrons de nous aimer. Vous pouvez également supprimer toutes vos données à tout moment, car elles vous appartiennent. Et résiliez votre abonnement quand vous le souhaitez.",
    feature8Title: "Autre",
    feature8Desc: "Hiperyon est votre partenaire idéal pour repousser les limites de l'IA et transformer vos idées en réalité. Découvrez tout ce que nous pouvons accomplir ensemble.",
    
    // Section with Mockup
    sectionTitle: "Découvrez une nouvelle façon d'interagir avec l'IA",
    sectionDescription: "Hiperyon n'est pas seulement une extension, c'est votre nouveau cerveau numérique. Imaginez une IA plus intuitive, capable de s'adapter à vos besoins, de retenir vos préférences et de transformer vos interactions en expériences mémorables. Avec Hiperyon, vous ne vous demandez plus ce que l'IA sait, vous savez qu'elle est là pour vous, comme une extension de votre esprit.",
    performanceTitle: "Performances révolutionnaires",
    aiStandard: "IA Standard",
  aiStandardDesc: "Performances limitées à 70%",
  HiperyonAITitle: "Hiperyon IA",
  HiperyonAIDesc: "Performances boostées à 130%",
    performanceConclusion: "Avec Hiperyon, vos interactions avec l'IA atteignent un niveau jamais vu auparavant.",
    metricsTitle: "Des gains mesurables et un impact écologique",
    metric1Title: "Précision des réponses",
    metric1Value: "+26 %",
    metric2Title: "Économie de tokens",
    metric2Value: "90 % économisés",
    metric3Title: "Satisfaction utilisateur",
    metric3Value: "+30 %",
    metric4Title: "Efficacité opérationnelle",
    metric4Value: "+25 %",
    metricsConclusion: "Grâce à Hiperyon, gagnez en rapidité et en performance avec une mémoire commune. Vous n'avez jamais besoin de vous répéter et gardez vos données en sécurité. Une solution efficace et durable adaptée à vos besoins.",
    ctaTitle: "Rejoignez Hiperyon dès maintenant !",
    ctaButton: "Commencez votre aventure",
    
    // Pricing
    'pricing.plan.free.title': 'Gratuit',
    'pricing.plan.free.description': 'Fonctionnalités de base',
    'pricing.plan.pro.title': 'Pro',
    'pricing.plan.pro.description': 'Pour aller plus loin',
    'pricing.plan.max.title': 'Max',
    'pricing.plan.max.description': 'Puissance maximale',
    'pricing.features.requests.500': '500 requêtes',
    'pricing.features.requests.2500': '2 500 requêtes',
    'pricing.features.requests.30000': '30 000 requêtes',
    'pricing.features.memory.10000': '10 000 mémoire',
    'pricing.features.memory.50000': '50 000 mémoire',
    'pricing.features.memory.500000': '500 000 mémoire',
    'pricing.features.support.48h': 'Support : 48h',
    'pricing.features.support.24h': 'Support : 24h',
    'pricing.features.support.6h': 'Support : 6h',
    'pricing.features.community.discord': 'Communauté : Discord',
    'pricing.features.tester.beta': 'Testeur : Beta test',
    'pricing.features.performance.best': 'Performance : Meilleur résultat et stockage',
    'pricing.features.group.private': 'Groupe : Groupe privé',
    
    // AI Models Showcase
    aiModelsTitle: "Compatible avec tous les modèles d'IA pour créer une mémoire commune",
    aiModelsSubtitle: "Hiperyon fonctionne avec tous vos modèles favoris, et encore plus de modèles à venir bientôt !",
    
    // Testimonials
    testimonialsTitle: "Ce que disent nos utilisateurs",
    testimonialsSubtitle: "Découvrez comment Hiperyon transforme leur productivité",
    testimonial1Name: "Thomas",
    testimonial1Role: "Client",
  testimonial1Comment: "Mais depuis que j'utilise Hiperyon, je tire le meilleur de tous les modèles d'IA. Peu importe lequel j'utilise, j'ai toujours le résultat optimal !",
    testimonial2Name: "Flavio",
    testimonial2Role: "Client",
    testimonial2Comment: "Hiperyon est très facile à prendre en main et c'est beaucoup moins cher que la concurrence. Pour le même prix, j'ai accès à tous les modèles et la qualité des réponses est nettement supérieure. Un vrai rapport qualité-prix imbattable.",
    testimonial3Name: "Aurelia",
    testimonial3Role: "Client",
    testimonial3Comment: "Ce qui m'impressionne le plus, c'est la transparence d'Hiperyon. Le truc fonctionne de façon simple et facile d'usage. On peut l'ajouter en mémoire facilement, on peut faire appel quand on veut à la mémoire. C'est plus pratique et très rapide !",
    testimonial4Name: "Thibaud",
    testimonial4Role: "Client",
    testimonial4Comment: "La possibilité de switcher entre différents LLM sans effort m'a permis d'optimiser complètement mon workflow. Je gagne tellement de temps maintenant qu'il est difficile d'imaginer comment je travaillais avant.",
    testimonial5Name: "Ali",
    testimonial5Role: "Client",
    testimonial5Comment: "Interface intuitive et extrêmement performante. L'accès à plusieurs LLM depuis une seule plateforme m'a changé la vie. Je l'utilise tous les jours et je la recommande à tous mes collègues.",
    testimonial6Name: "Adrien",
    testimonial6Role: "Client",
    testimonial6Comment: "La mémoire contextuelle est révolutionnaire. Hiperyon se souvient de mes préférences et du contexte de mes conversations. Cela me permet de travailler 4x plus vite qu'avant et c'est franchement incroyable.",
  },
  en: {
  'pricing.features.tester.none': 'Tester: None',
  'pricing.features.performance.none': 'Performance: None',
  'pricing.features.group.none': 'Group: None',
  'pricing.card.popular': 'Popular',
  'pricing.included': 'Included by default',
  'pricing.subscribe': 'Subscribe',
  'pricing.checking': 'Checking...',
  'pricing.already': 'Already subscribed',
  'pricing.autorenew': 'Auto-renewal',
  'pricing.per.month': 'month',
  'pricing.per.year': 'year',
  'pricing.header.badge': 'Pricing',
  'pricing.header.title': 'Choose your plan',
  'pricing.header.subtitle': 'Simple and transparent pricing for all your needs',
  'pricing.toggle.monthly': 'Monthly',
  'pricing.toggle.yearly': 'Yearly',
  'pricing.yearly.badge': '2 months free',
    // Navigation
    login: "Login",
    signup: "Sign Up",
    
    // Hero Section
    heroTitle: "30% More Performance",
    heroSubtitle: "For all your LLMs with a unified memory",
    heroDescription: "Hiperyon lets you switch between models as easily as changing shirts — without ever having to remind the AI what you want.",
    getStarted: "Get Started Free",
    viewPricing: "View Pricing",
    dashboardTitle: "Hiperyon Dashboard",
    
    // Boost Section
    boostTitle: "Get 30% better results with Hiperyon",
    boostDescription: "Enhanced performance and guaranteed speed. Your contextual memory follows you through every model switch.",
    
    // Mockup Section
    mockupTitle: "Our simple and \n powerful extension",
    mockupDescription: "A universal memory layer for all your AI models. Write once, use everywhere.",
    
    // FAQ
    faqTitle: "Frequently Asked Questions",
    faqSubtitle: "Everything you need to know about Hiperyon",
    faq1Q: "What does the Hiperyon Chrome extension do?",
    faq1A: "It adds a memory layer to browser-based AI tools. It captures the context of your conversations and makes it available across tools like ChatGPT, Claude, Perplexity, etc. All personal data in your possession is used to enable optimal functionality, as memory is directly integrated into the LLM you're using.",
    faq2Q: "Is the Hiperyon Chrome extension free?",
    faq2A: "Yes, the basic extension is free. We also offer premium plans with advanced features.",
    faq3Q: "How does it decide what to remember?",
    faq3A: "Hiperyon uses advanced AI algorithms to automatically identify and save the most relevant information from your conversations.",
    faq4Q: "Which AI tools are supported?",
    faq4A: "Currently, we support ChatGPT, Claude, Perplexity, Gemini, and Replit. More integrations coming soon!",
    faq5Q: "Does memory sync across devices?",
    faq5A: "Yes. Memory is saved on the Hiperyon cloud server, so your data syncs and works across multiple devices.",
    faq6Q: "Can I view or edit what's stored?",
    faq6A: "Absolutely. The Hiperyon dashboard lets you view, search, edit, or delete any memory. You can also add memories manually.",
    faq7Q: "How is memory applied in prompts?",
    faq7A: "For all supported AIs, you can trigger memory manually via a button or keyboard shortcut. Use the Ctrl+Q keyboard shortcut to choose whether the AI uses memory or not. Perplexity support coming soon.",
    faq8Q: "Can I disable memory for a specific session or tool?",
    faq8A: "Yes. You can disable memory per tool or pause memory capture entirely from the dashboard.",
    faq9Q: "Do my data really belong to me?",
    faq9A: "Yes, 100% of your data belongs to you. You have complete control and can view, edit, or delete it anytime from your dashboard.",
    faq10Q: "Do you sell my data to third parties?",
    faq10A: "No, never. We don't sell, share, or commercially exploit your data. We use your data only to improve your personal experience.",
    faq11Q: "How is my data secured?",
    faq11A: "Your conversations and memories are encrypted in transit (SSL/TLS) and at rest. Even our servers cannot access your sensitive data. We use the highest security standards in the industry.",
    faq12Q: "Are you GDPR compliant?",
    faq12A: "Yes, Hiperyon fully respects GDPR and data protection regulations. You have the right to access, rectify, be forgotten, and data portability.",
    
    // Newsletter
    newsletterTitle: "Try to win 6 months free!",
    newsletterDescription: "Sign up for our newsletter and enter the draw to win 6 months of Hiperyon MAX subscription.",
    newsletterPlaceholder: "Enter your email address",
    newsletterButton: "I'm in!",
    newsletterDisclaimer: "By signing up, you agree to receive our news and exclusive offers.",
    
    // Loading
    loading: "Loading...",
    
    // Features Section
    featuresTitle: "Powerful Features",
    featuresSubtitle: "Discover everything Hiperyon can do for you",
    feature1Title: "Built for data security",
    feature1Desc: "Hiperyon is designed to ensure the privacy and security of your personal data while delivering optimal performance.",
    feature2Title: "Ease of use",
    feature2Desc: "Hiperyon is incredibly simple to use. A single action is all it takes to call up your memory and enrich your interactions.",
    feature3Title: "Unique pricing",
    feature3Desc: "Our prices are the best on the market. Enjoy a free plan to discover our service with no hidden fees or credit card required.",
    feature4Title: "100% availability",
    feature4Desc: "We strive to guarantee the highest possible uptime, all the time, so you can count on Hiperyon without interruption.",
    feature5Title: "No repetition across models",
    feature5Desc: "Switch from ChatGPT to Claude, from Gemini to Mistral without ever repeating yourself. Your context follows instantly.",
    feature6Title: "Intelligent memory",
    feature6Desc: "Our AI system analyzes and remembers intelligently. No redundancy, no context loss when switching models.",
  feature7Title: "Cancel your subscription whenever you want",
  feature7Desc: "If you don't like Hiperyon, we'll convince you to love us. You can also delete all your data at any time, because it belongs to you. And cancel your subscription whenever you want.",
    feature8Title: "Other",
    feature8Desc: "Hiperyon is your ideal partner to push the boundaries of AI and turn your ideas into reality. Discover everything we can accomplish together.",
    
    // Section with Mockup
    sectionTitle: "Discover a new way to interact with AI",
    sectionDescription: "Hiperyon isn't just an extension, it's your new digital brain. Imagine a more intuitive AI, capable of adapting to your needs, remembering your preferences, and transforming your interactions into memorable experiences. With Hiperyon, you no longer wonder what the AI knows, you know it's there for you, like an extension of your mind.",
    performanceTitle: "Revolutionary Performance",
    aiStandard: "Standard AI",
  aiStandardDesc: "Performance limited to 70%",
  HiperyonAITitle: "Hiperyon AI",
  HiperyonAIDesc: "Performance boosted to 130%",
    performanceConclusion: "With Hiperyon, your AI interactions reach unprecedented levels.",
    metricsTitle: "Measurable gains and ecological impact",
    metric1Title: "Response accuracy",
    metric1Value: "+26%",
    metric2Title: "Token savings",
    metric2Value: "90% saved",
    metric3Title: "User satisfaction",
    metric3Value: "+30%",
    metric4Title: "Operational efficiency",
    metric4Value: "+25%",
    metricsConclusion: "With Hiperyon, gain speed and performance with shared memory. You never need to repeat yourself and keep your data secure. An efficient and sustainable solution tailored to your needs.",
    ctaTitle: "Join Hiperyon now!",
    ctaButton: "Start your adventure",
    
    // Pricing
    'pricing.plan.free.title': 'Free',
    'pricing.plan.free.description': 'Basic features',
    'pricing.plan.pro.title': 'Pro',
    'pricing.plan.pro.description': 'Go further',
    'pricing.plan.max.title': 'Max',
    'pricing.plan.max.description': 'Maximum power',
    'pricing.features.requests.500': '500 requests',
    'pricing.features.requests.2500': '2,500 requests',
    'pricing.features.requests.30000': '30,000 requests',
    'pricing.features.memory.10000': '10,000 memory',
    'pricing.features.memory.50000': '50,000 memory',
    'pricing.features.memory.500000': '500,000 memory',
    'pricing.features.support.48h': 'Support: 48h',
    'pricing.features.support.24h': 'Support: 24h',
    'pricing.features.support.6h': 'Support: 6h',
    'pricing.features.community.discord': 'Community: Discord',
    'pricing.features.tester.beta': 'Tester: Beta test',
    'pricing.features.performance.best': 'Performance: Best results and storage',
    'pricing.features.group.private': 'Group: Private group',
    
    // AI Models Showcase
    aiModelsTitle: "Compatible with all AI models to create shared memory",
    aiModelsSubtitle: "Hiperyon works with all your favorite models, and even more models coming soon!",
    
    // Testimonials
    testimonialsTitle: "What our users say",
    testimonialsSubtitle: "Discover how Hiperyon transforms their productivity",
    testimonial1Name: "Thomas",
    testimonial1Role: "Client",
    testimonial1Comment: "But since I started using Hiperyon, I get the best out of every AI model. No matter which one I use, I always get the optimal result!",
    testimonial2Name: "Flavio",
    testimonial2Role: "Client",
    testimonial2Comment: "Hiperyon is very easy to use and much cheaper than the competition. For the same price, I get access to all models and the quality of the answers is much higher. Truly unbeatable value for money.",
    testimonial3Name: "Aurelia",
    testimonial3Role: "Client",
    testimonial3Comment: "What impresses me most is Hiperyon's transparency. It works simply and is easy to use. You can add it to memory easily, and call on memory whenever you want. It's more practical and very fast!",
    testimonial4Name: "Thibaud",
    testimonial4Role: "Client",
    testimonial4Comment: "The ability to switch between different LLMs effortlessly has completely optimized my workflow. I save so much time now that it's hard to imagine how I worked before.",
    testimonial5Name: "Ali",
    testimonial5Role: "Client",
    testimonial5Comment: "Intuitive and extremely powerful interface. Access to multiple LLMs from a single platform has changed my life. I use it every day and recommend it to all my colleagues.",
    testimonial6Name: "Adrien",
    testimonial6Role: "Client",
    testimonial6Comment: "The contextual memory is revolutionary. Hiperyon remembers my preferences and the context of my conversations. This allows me to work 4x faster than before and it's honestly incredible.",
  }
};
